import type { IBuildingEquipment } from 'shared/types/buildingCard';
import { formatDecimal } from 'shared/utils/format';

/** Строки лифтов или кранов, как `liftTypes`/`cranageTypes` в `detail/index.html` монолита. Неизвестный тип пропускаем */
export function getEquipmentLines(items: IBuildingEquipment[], labels: Partial<Record<string, string>>): string[] {
  return items.reduce<string[]>((lines, { type, count, loadCapacity }) => {
    const label = labels[type];

    if (label) {
      const countText = count ? `, ${count} шт.` : '';
      const capacityText = loadCapacity ? `, грузоподъемность ${formatDecimal(loadCapacity)} т.` : '';

      lines.push(`${label}${countText}${capacityText}`);
    }

    return lines;
  }, []);
}
